import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'

export const HeroColumns = styled.div`
    display: flex;
    justify-content: space-between;

    margin-block-end: 16px;

    ${belowTablet`
        flex-direction: column;

        row-gap: 8px;
    `}
`